import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isCollapse: false,
};
const globalSlice = createSlice({
  name: "global",
  initialState: initialState,
  reducers: {
    setIsCollapse: (state, action) => {
      state.isCollapse = action.payload;
    },
  },
});

export const globalAction = globalSlice.actions;

export default globalSlice.reducer;
